import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decimalComma',
  standalone: false
})
export class DecimalCommaPipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    return value === null || value === undefined ? '' : String(value).replace('.', ',');
  }
}
